import { render } from "./CardImg.vue?vue&type=template&id=01241c4e&scoped=true"
import script from "./CardImg.vue?vue&type=script&lang=js"
export * from "./CardImg.vue?vue&type=script&lang=js"

import "./CardImg.vue?vue&type=style&index=0&id=01241c4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01241c4e"],['__file',"src/components/mdbvue/Components/CardImg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01241c4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01241c4e', __exports__)) {
    api.reload('01241c4e', __exports__)
  }
  
  module.hot.accept("./CardImg.vue?vue&type=template&id=01241c4e&scoped=true", () => {
    api.rerender('01241c4e', render)
  })

}


export default __exports__